import React from "react"
import SEO from "../components/SEO"
import Layout from "../components/Layout"
import Logo from "../components/Logo"
import { makeStyles } from "@material-ui/core/styles"
import {
  Typography,
  Button,
  Paper,
  Card,
  CardHeader,
  CardContent,
  Grid,
  CardActions,
  List,
  ListItem,
  Checkbox,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core"
import { Link } from "gatsby"

const useStyles = makeStyles(theme => ({
  jumbotron: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  grid: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    backgroundColor: "#e9e9e9",
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
  },
  imgWrapper: {
    width: 150,
    flexShrink: 0,
    marginRight: theme.spacing(4),
  },
  textWrapper: {
    flexGrow: 1,
  },
  list: {
    paddingBottom: theme.spacing(2),
    margin: 0,
  },
  listItem: {
    margin: 0,
    paddingTop: 0,
    paddingBottom: 0,
  },
  nested: {
    paddingLeft: theme.spacing(4),
    paddingTop: 0,
    paddingBottom: 0,
    margin: 0,
  },
}))

const RoadmapList = ({ data, title }) => {
  const classes = useStyles()
  return (
    <Paper>
      <Typography variant="h6" className={classes.paper}>
        {title}
      </Typography>
      <List className={classes.list} disablePadding>
        {data.map(item => (
          <>
            <ListItem key={item.name} className={classes.listItem}>
              <ListItemIcon>
                <Checkbox
                  edge="end"
                  checked={item.completed}
                  tabIndex={-1}
                  disableRipple
                  color="primary"
                  inputProps={{ "aria-labelledby": item.name }}
                />
              </ListItemIcon>
              <ListItemText primary={item.name} />
            </ListItem>
            {item.children && (
              <List disablePadding>
                {item.children.map(child => (
                  <ListItem key={child.name} className={classes.nested}>
                    <ListItemIcon>
                      <Checkbox
                        edge="end"
                        checked={child.completed}
                        tabIndex={-1}
                        disableRipple
                        color="primary"
                        inputProps={{ "aria-labelledby": child.name }}
                      />
                    </ListItemIcon>
                    <ListItemText primary={child.name} />
                  </ListItem>
                ))}
              </List>
            )}
          </>
        ))}
      </List>
    </Paper>
  )
}

const IndexPage = () => {
  const classes = useStyles()

  const LreReactRoadmapData = [
    { name: "Overview", completed: true },
    { name: "Roadmap", completed: false },
    {
      name: "Components",
      completed: false,
      children: [
        { name: "DatePicker", completed: true },
        { name: "TextField", completed: true },
        { name: "Select", completed: true },
        { name: "MultiSelect", completed: true },
        { name: "Switch", completed: true },
        { name: "Table", completed: false },
        { name: "useTable", completed: false },
        { name: "useGraph", completed: false },
        { name: "useVisibility", completed: false },
      ],
    },
  ]

  const LreStarterKitRoadmapData = [
    { name: "Overview", completed: true },
    { name: "Main Concepts", completed: true },
    {
      name: "Getting Started",
      completed: true,
    },
    { name: "Working with an Existing Project", completed: false },
    {
      name: "Advanced Guides",
      completed: false,
      children: [
        {
          name: "Using a Starter Kit for Data Management",
          completed: false,
        },
        {
          name: "Setting up Permissions and Roles in Auth0",
          completed: false,
        },
        {
          name: "Integrating Mapbox into the Starter Kits",
          completed: false,
        },
        { name: "Developing the Backend API", completed: false },
      ],
    },
  ]

  const WebDevRoadmapData = [
    { name: "Overview", completed: true },
    {
      name: "Fundamentals",
      completed: true,
      children: [
        { name: "Intro to HTML", completed: false },
        { name: "Intro to CSS", completed: false },
        { name: "Intro to JS", completed: false },
        {
          name: "Development Paradigms (CMS, custom app,...)",
          completed: false,
        },
        { name: "Design and Mockups", completed: false },
        { name: "Version Control with Git and Github", completed: false },
        { name: "Local Dev vs Remote Dev", completed: false },
      ],
    },
    { name: "The Internet", completed: true },
    { name: "Setting Up Your Development Environment", completed: true },
    { name: "Agile Development and Workflows", completed: false },
    {
      name: "LRE Tech and Tools",
      completed: false,
      children: [
        { name: "React", completed: false },
        { name: "Create React App", completed: false },
        { name: "Material UI", completed: false },
        { name: "Material Table", completed: false },
        { name: "Mapbox", completed: false },
        { name: "Recharts", completed: false },
        { name: "Auth0", completed: false },
        { name: "Node.js", completed: false },
        { name: "Express", completed: false },
        { name: "Sequelize", completed: false },
        { name: "Postgresql", completed: false },
        { name: "Drupal", completed: false },
        { name: "Github", completed: false },
        { name: "Sentry", completed: false },
        { name: "Adobe XD", completed: false },
        { name: "Asana", completed: false },
        { name: "Slack", completed: false },
      ],
    },
    {
      name: "Hosting",
      completed: false,
      children: [
        { name: "Netlify", completed: false },
        { name: "Heroku", completed: false },
        { name: "AWS", completed: false },
      ],
    },
    {
      name: "Guides",
      completed: false,
      children: [
        { name: "Working with Forms in React", completed: false },
        { name: "Create React App", completed: false },
      ],
    },
  ]

  const PostgresRoadmapData = []
  const DrupalRoadmapData = []
  const MapboxRoadmapData = [
    { name: "Overview", completed: true },
    { name: "Mapbox Studio", completed: false },
    { name: "Mapbox GL JS", completed: false },
    {
      name: "Advanced Guides",
      completed: false,
      children: [{ name: "Using the Uploads API", completed: false }],
    },
  ]
  const ServersRoadmapData = []

  return (
    <Layout>
      <SEO title="Home" />
      <div className={classes.jumbotron}>
        <div className={classes.imgWrapper}>
          <Logo />
        </div>
        <div className={classes.textWrapper}>
          <Typography variant="h4" gutterBottom>
            LRE Water Knowledge Base
          </Typography>
          <Typography variant="body1" paragraph>
            This site is intended to serve as a Knowledge base for the
            Technology and Innovation group. This site will contain
            documentation specific to common workflows and tools, as well as
            documentation for internal products such as the Starterkit and the
            lre-react library.
          </Typography>
          <Typography variant="body1" paragraph>
            You can use the link cards below, the menu icon, or even the search
            bar to navigate this site. If you are curious about what is and is
            not documented in the Knowledge Base, please refer to the roadmap
            below. If you are interested in contributing, please contact Ben
            Tyler.
          </Typography>
        </div>
      </div>
      <Grid container className={classes.grid} spacing={2}>
        <Grid item xs={12} sm={4}>
          <Card>
            <CardHeader title="LRE Starter Kits" />
            <CardContent>
              <Typography variant="body2">
                The LRE Starter Kits are templates that provide a massive head
                start when creating a Full Stack JavaScript application.
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                component={Link}
                to="/lre-starter-kit/overview"
                color="primary"
              >
                Learn More
              </Button>
            </CardActions>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card>
            <CardHeader title="LRE React" />
            <CardContent>
              <Typography variant="body2">
                LRE React is a library of reusable components tailored
                specifically to LRE Water use cases.
              </Typography>
            </CardContent>
            <CardActions>
              <Button component={Link} to="/lre-react/overview" color="primary">
                Learn More
              </Button>
            </CardActions>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card>
            <CardHeader title="Drupal Docs" />
            <CardContent>
              <Typography variant="body2">
                Learn the ins and outs of the powerful CMS Drupal.
              </Typography>
            </CardContent>
            <CardActions>
              <Button component={Link} to="/drupal/overview" color="primary">
                Learn More
              </Button>
            </CardActions>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card>
            <CardHeader title="Web Development" />
            <CardContent>
              <Typography variant="body2">
                Learn the fundamentals of web development.
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                color="primary"
                component={Link}
                to="/web-development/overview"
              >
                Learn More
              </Button>
            </CardActions>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card>
            <CardHeader title="Mapbox" />
            <CardContent>
              <Typography variant="body2">
                Learn the fundamentals of Mapbox.
              </Typography>
            </CardContent>
            <CardActions>
              <Button color="primary" component={Link} to="/mapbox/overview">
                Learn More
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
      <div>
        <Typography variant="h4" gutterBottom>
          Knowledge Base Roadmap
        </Typography>
        <Typography variant="body1" paragraph>
          This Knowledge Base is still very much a work in progress. The
          following list is meant to document the progress that has been made
          and what is still outstanding.
        </Typography>
      </div>
      <Grid container spacing={2} className={classes.grid}>
        <Grid item xs={12} sm={6}>
          <RoadmapList data={LreReactRoadmapData} title="LRE React" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <RoadmapList
            data={LreStarterKitRoadmapData}
            title="LRE Starter Kits"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <RoadmapList data={WebDevRoadmapData} title="Web Development" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <RoadmapList data={DrupalRoadmapData} title="Drupal" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <RoadmapList data={MapboxRoadmapData} title="Mapbox" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <RoadmapList data={PostgresRoadmapData} title="PostgreSQL" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <RoadmapList data={ServersRoadmapData} title="Servers" />
        </Grid>
      </Grid>
    </Layout>
  )
}

export default IndexPage
